export const FILE_IMPORT_LIST = 'FILE_IMPORT_LIST';
export const FILE_IMPORT_CLEAR_FILE = 'FILE_IMPORT_CLEAR_FILE';
export const FILE_IMPORT_LIST_CUSTOMERS = 'FILE_IMPORT_LIST_CUSTOMERS';